import React from "react";

const FlowTick = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.79337 7.79354C2.97643 7.61049 3.27322 7.61049 3.45628 7.79354L5.62483 9.96209L11.5434 4.04354C11.7264 3.86049 12.0232 3.86049 12.2063 4.04354C12.3893 4.2266 12.3893 4.5234 12.2063 4.70646L5.95628 10.9565C5.77322 11.1395 5.47643 11.1395 5.29337 10.9565L2.79337 8.45646C2.61031 8.2734 2.61031 7.9766 2.79337 7.79354Z"
        fill="white"
      />
    </svg>
  );
};

export default FlowTick;
